import { render } from "./GiftCardSaleCard.vue?vue&type=template&id=54449580"
import script from "./GiftCardSaleCard.vue?vue&type=script&lang=js"
export * from "./GiftCardSaleCard.vue?vue&type=script&lang=js"

import "./GiftCardSaleCard.vue?vue&type=style&index=0&id=54449580&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QInput});
